import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // ✅ AJOUTER CECI
import App from './App';

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>  {/* ✅ ENTOURER APP AVEC BROWSERROUTER */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);